import { SVGProps } from "react";
export const OfflineReady = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={100}
    height={100}
    {...props}
  >
    <g fill="none">
      <path d="M18.18 81.82a45 45 0 0 0 63.64-63.64" />
      <path strokeDasharray="10,5" d="M81.82 18.18a45 45 0 0 0-63.64 63.64" />
    </g>
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m30 50 15 15 25-30"
    />
  </svg>
);
export const Unknown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={100}
    height={100}
    {...props}
  >
    <g fill="none">
      <path d="M18.18 81.82a45 45 0 0 0 63.64-63.64" />
      <path strokeDasharray="10,5" d="M81.82 18.18a45 45 0 0 0-63.64 63.64" />
    </g>
    <path fill="none" strokeLinecap="round" d="M50 28v40" />
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m35 53 15 17 15-17"
    />
  </svg>
);

export const Loading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={100}
    height={100}
    {...props}
  >
    <g fill="none">
      <path d="M18.18 81.82a45 45 0 0 0 63.64-63.64" />
      <path strokeDasharray="10,5" d="M81.82 18.18a45 45 0 0 0-63.64 63.64" />
    </g>
    <circle cx={30} cy={48} r={5} />
    <circle cx={50} cy={48} r={5} />
    <circle cx={70} cy={48} r={5} />
  </svg>
);

export const Failed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={100}
    height={100}
    {...props}
  >
    <circle cx={50} cy={50} r={45} fill="none" />
    <path strokeLinecap="round" d="m35 35 30 30M65 35 35 65" />
  </svg>
);

export type SongStatus = "ERROR" | "UNKNOWN" | "READY" | "LOADING";

export const StatusIcon = ({
  status,
  ...props
}: SVGProps<SVGSVGElement> & { status: SongStatus }) => {
  if (status === "UNKNOWN")
    return (
      <Unknown
        className="w-4 h-4  stroke-[#e5c05c] cursor-pointer opacity-70  stroke-[7]"
        {...props}
      />
    );

  if (status === "ERROR")
    return <Failed className="w-4 h-4 stroke-red-500  stroke-[7]" {...props} />;

  if (status === "LOADING")
    return (
      <Loading
        className="w-4 h-4 stroke-[#e5c05c] opacity-80  stroke-[7]"
        {...props}
      />
    );

  return (
    <OfflineReady className="w-4 h-4 stroke-[#e5c05c] stroke-[7]" {...props} />
  );
};
export const LoopIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={100}
    height={100}
    {...props}
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M30 35 20 25l10-10"
    />
    <path fill="none" strokeLinecap="round" d="M20 25h40a20 20 0 0 1 20 20" />
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m70 65 10 10-10 10"
    />
    <path fill="none" strokeLinecap="round" d="M80 75H40a20 20 0 0 1-20-20" />
  </svg>
);

export const LoopOnceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={100}
    height={100}
    {...props}
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M30 35 20 25l10-10"
    />
    <path fill="none" strokeLinecap="round" d="M20 25h40a20 20 0 0 1 20 20" />
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m70 65 10 10-10 10"
    />
    <path fill="none" strokeLinecap="round" d="M80 75H40a20 20 0 0 1-20-20" />
    <text
      x={50}
      y={58}
      fontFamily="Arial, sans-serif"
      fontSize={24}
      strokeWidth={2}
      textAnchor="middle"
    >
      {"1"}
    </text>
  </svg>
);
